<template>
    <div id="wrap">
        <!-- 서브 컨텐츠 헤더 -->
        <header id="header"
            :class="{ on: state.isMenuActive }">
            <div class="inner">
                <h1 id="logo"><a href="/main.html" title="메인으로 이동"><span class="text_hidden">한국토지신탁</span></a></h1>

                <!-- 서브 컨텐츠 상단 메뉴 -->
                <nav id="gnb">
                    <MenuNavigation 
                        :onRootDepthMenuClick="eventHandler.onRootDepthMenuClick" 
                        :onTwoDepthMenuClick="eventHandler.onTwoDepthMenuClick"
                        :onSideButtonClick="eventHandler.onSideButtonClick"/>
                </nav>

                <button type="button" title="메뉴" id="menuToggle" @click="state.isMenuActive = state.isMenuActive ? false : true"><span></span><span></span><span></span></button>
            </div>
        </header>
        
        <!-- 타이틀 영역 -->
        <div id="sub-visual" :class="shareState.subTitleInfo.backGroundStyle">
            <div class="s-inner">
                <ul>
                    <li class="home"><span class="text_hidden">Home</span></li>
                    <li>{{shareState.subTitleInfo.oneDeptMenuTitle}}</li>
                    <li>{{shareState.subTitleInfo.twoDeptMenuTitle}}</li>
                </ul>
                <h3>{{shareState.subTitleInfo.twoDeptMenuTitle}}</h3>
            </div>
        </div>

        <!-- 컨텐츠 영역 -->
        <router-view :key="$route.fullPath"/>

        <!-- 푸터 영역 -->
        <Footer/>
    </div>
</template>
<script>
import MenuNavigation from '@/components/MenuNavigation.vue';
import { reactive } from '@vue/reactivity';
import { ref, provide, watch } from 'vue';
import { useStore } from 'vuex';
import { onMounted } from '@vue/runtime-core';
import { useRoute, useRouter } from 'vue-router';
import { menuDataSource } from '@/modules/menu-management.js';
import { common } from '@/modules/common.js';
import Footer from '@/components/Footer.vue';

export default {
    components: {
        MenuNavigation,
        Footer,
    },
    setup() {

        // 공통 state
        const shareState = reactive({
            // 서브 타이틀 정보
            subTitleInfo: {
                backGroundStyle: null,
                oneDeptMenuTitle: null,
                twoDeptMenuTitle: null,
            }
        });

        // 자식 컴포넌트에서 변경 사항을 감지하고 반영
        watch(shareState, (newVal) => {
            shareState.subTitleInfo.backGroundStyle = newVal.items.backGroundStyle;
            shareState.subTitleInfo.oneDeptMenuTitle = newVal.items.oneDeptMenuTitle;
            shareState.subTitleInfo.twoDeptMenuTitle = newVal.items.twoDeptMenuTitle;
        });

        // 컴포넌트 하위항목에 shareState를 제공하기위해 setup() 함수에 provide제공
        provide('shareState', shareState);

        // 라우터
        const router = useRouter();

        // 라우트
        const route = useRoute();

        // 스토어
        const store = useStore();

        // state(변수)
        const state = reactive({

            backgroundClass: null,

            // 선택한 최상위 타이틀 정보
            selectedRootMenuInfo: null,

            // 선택한 2뎁스 타이틀 정보
            selectedTwoDepthMenuInfo: null,

            // 상단 메뉴영역 active 여부
            isMenuActive: false,
        });

        // 메소드
        const methods = {

            // 초기화 메서드
            initialize: (currentMenuInfo) => {

                // backgroundClass 설정
                shareState.subTitleInfo.backGroundStyle = menuDataSource.find((item) => item.menuId === currentMenuInfo.parentMenuId).backgroundClass

                // 2뎁스 타이틀 정보 설정
                shareState.subTitleInfo.twoDeptMenuTitle = currentMenuInfo.title;

                // 최상위 타이틀 정보 설정
                shareState.subTitleInfo.oneDeptMenuTitle = menuDataSource.find((item) => item.menuId === currentMenuInfo.parentMenuId).title

                // 스크롤 이벤트 설정
                document.addEventListener('scroll', () => {

                    const headerElement = document.getElementById("header");

                    if (document.documentElement.scrollTop > 0) {

                        if (!headerElement.classList.contains('scroll-on')) headerElement.classList.add('scroll-on');
                    }
                    else headerElement.classList.remove('scroll-on');
                });
            }
        }

        // 이벤트 핸들러
        const eventHandler = {

            /**
             * 모바일버전 뎁스 메뉴 화살표 클릭 이벤트 처리
             * @param {any} event
             */
             onSideButtonClick: (event) => {

                event.target.parentNode.classList.toggle('on');
            },

            // 최상위 메뉴 클릭 이벤트 핸들러
            onRootDepthMenuClick: (rootMenuInfo) => {

                // backgroundClass 설정
                shareState.subTitleInfo.backGroundStyle = rootMenuInfo.backgroundClass

                // 타이틀 정보 설정
                shareState.subTitleInfo.oneDeptMenuTitle = rootMenuInfo.title
                shareState.subTitleInfo.twoDeptMenuTitle = rootMenuInfo.children.find((item) => item.path === rootMenuInfo.rootPath).title

                // 모바일 뎁스 닫기
                state.isMenuActive = false;
            },

            // 2뎁스 메뉴 클릭 이벤트 핸들러
            onTwoDepthMenuClick: (event, rootMenuInfo, twoMenuInfo) => {

                // backgroundClass 설정
                shareState.subTitleInfo.backGroundStyle = rootMenuInfo.backgroundClass

                // 타이틀 정보 설정
                shareState.subTitleInfo.oneDeptMenuTitle = rootMenuInfo.title
                shareState.subTitleInfo.twoDeptMenuTitle = twoMenuInfo.title

                // 모바일 뎁스 닫기
                state.isMenuActive = false; 
                
                // 모바일 뎁스 현재 열린것 제외하고 나머지 닫기
                const rootMenuElements = event.target.parentNode.parentNode.parentNode.parentNode.querySelectorAll("div");
                rootMenuElements.forEach(element => {
                    
                    if(element.querySelector("a").text === rootMenuInfo.title) element.parentNode.querySelector("div").classList.add('on');
                    else element.parentNode.querySelector("div").classList.remove('on');
                })

                // 최상단으로 스크롤 이동
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        }

        // Dom 객체 이후
        onMounted(() => {

            // 현재 메뉴 정보 (라우터 경로 기준)
            const currentMenuInfo = menuDataSource.find(data => {

                return data.path === route.path || (data.detailPath && data.detailPath.includes(route.fullPath.split('?')[0]));
            });

            // 초기화
            methods.initialize(currentMenuInfo);
        });

        return {
            state,
            store,
            eventHandler,
            methods,
            router,
            common,
            shareState,
        }
    },
}
</script>